import classNames from 'classnames';
import { DetailsContainer } from 'components/institution/Unit/StudentsRegister/Details/DetailsContainer';
import { useTranslator } from 'components/shared/hooks';
import React from 'react';
import { Page } from 'components/layout/panel/Page/Page';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { Route, Routes, useLocation, useParams } from 'react-router-dom';
import { EditorEditContainer } from 'components/institution/Unit/Editor/EditorEditContainer';
import {
  ROUTE_INSTITUTION_UNIT_EDIT,
  ROUTE_INSTITUTIONS,
  ROUTE_STUDENTS_REGISTER_DETAILS,
  ROUTE_STUDENTS_REGISTER_ROLLBACK,
} from 'config/routes';
import { useStyles } from 'views/Panel/Institutions/Unit/UnitEdit/UnitEdit.styles';
import { push } from 'utils/navigation/navigate';
import { makePath } from 'utils/navigation/makePath';
import { relativePath } from 'utils/navigation/relativePath';

interface LocationState {
  fromDetails?: unknown;
}

const UnitEditForm: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const state = location.state as LocationState | null;

  return (
    <EditorEditContainer
      id={id}
      goBack={() => push(ROUTE_INSTITUTIONS)}
      fromStudentRegisterDetails={!!(state && state.fromDetails)}
    />
  );
};

const StudentsRegisterDetails: React.FC = () => {
  const trans = useTranslator();
  const { id, registerId, date } = useParams<{ id: string; registerId: string; date?: string }>();

  return (
    <>
      <Breadcrumb label={trans('BREADCRUMB.UNITS.STUDENT-REGISTER')} static />
      <DetailsContainer
        unitId={id}
        registerId={registerId}
        rollbackDate={date}
        onGoBack={() => push(makePath(ROUTE_INSTITUTION_UNIT_EDIT, { id }), { fromDetails: true })}
      />
    </>
  );
};

export const UnitEdit: React.FC = () => {
  const trans = useTranslator();
  const { id } = useParams<{ id: string }>();
  const classes = useStyles();

  return (
    <Page title={trans('INSTITUTIONS.UNIT.TITLE.EDIT')}>
      <Breadcrumb label={trans('BREADCRUMB.UNITS.UNIT-EDIT')} to={makePath(ROUTE_INSTITUTION_UNIT_EDIT, { id })} />

      <div className={classNames('container-fluid', classes.container)}>
        <Routes>
          <Route
            path={relativePath(ROUTE_INSTITUTION_UNIT_EDIT, ROUTE_INSTITUTION_UNIT_EDIT)}
            element={<UnitEditForm />}
          />
          <Route
            path={relativePath(ROUTE_STUDENTS_REGISTER_DETAILS, ROUTE_INSTITUTION_UNIT_EDIT)}
            element={<StudentsRegisterDetails />}
          />
          <Route
            path={relativePath(ROUTE_STUDENTS_REGISTER_ROLLBACK, ROUTE_INSTITUTION_UNIT_EDIT)}
            element={<StudentsRegisterDetails />}
          />
        </Routes>
      </div>
    </Page>
  );
};
